module.exports = ".document-p-icon{ padding-left: 10px;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/portfolio/possession/possession.component.css
// module id = ./src/app/modules/dashboard/portfolio/possession/possession.component.css
// module chunks = dashboard.module